import HeaderStickyObserver from './observers/sticky';
import HeaderMomentShowHideObserver from './observers/moment-show-hide';
import HeaderShowHideObserver from './observers/show-hide';
import HeaderHideSectionObserver from './observers/hide-section';
import HeaderHasHiddenElement from './observers/has-hidden-element';
import HeaderFloatingObserver from './observers/floating';
import HeaderWithoutBehaviorObserver from './observers/without-behavior';

export default class Header {
  constructor(el, config, observers) {
    this.element = typeof el === 'string' ? document.querySelector(el) : el;
    this.config = config;
    this.observers = observers && Object.prototype.toString.call(observers) === '[object Object]' ? observers : {};
    this.viewport = 'xs';
    this.defaults = {
      fixMoment: 0,
      fixMomentClasses: null,
      fixMomentExclude: null,
      fixEffect: 'slide',
      breakpoint: 'lg',
      breakpointsMap: {
        md: 768,
        sm: 576,
        lg: 992,
        xl: 1200,
      },
      effectCompensation: false,
      effectCompensationStartClass: false,
      effectCompensationEndClass: false,
    };
  }

  init() {
    const self = this,
      element = this.element;
    let dataSettings = element.hasAttribute('data-ua-header-options')
      ? JSON.parse(element.getAttribute('data-ua-header-options'))
      : {};

    if (!element || element.hasAttribute('Header')) {
      return;
    }

    this.config = Object.assign({}, this.defaults, dataSettings, this.config);

    this._detectObservers();
    this.fixMediaDifference(this.element);
    this.checkViewport();

    onScroll();
    document.addEventListener('scroll', onScroll);
    onResize();
    window.addEventListener('resize', onResize);

    function onScroll() {
      window.Header = null;

      if (window.scrollY < self.config.fixMoment - 100 && self.config.effectCompensation === true) {
        element.style.top = -window.scrollY;
        element.classList.add(self.config.effectCompensationStartClass);
        element.classList.remove(self.config.effectCompensationEndClass);
      } else if (self.config.effectCompensation === true) {
        element.style.top = 0;
        element.classList.add(self.config.effectCompensationEndClass);
        element.classList.remove(self.config.effectCompensationStartClass);
      }

      if (element.hasAttribute('Header')) {
        self.notify();
      }

      element.setAttribute('Header', true);
    }

    function onResize() {
      if (self.resizeTimeOutId) {
        clearTimeout(self.resizeTimeOutId);
      }

      self.resizeTimeOutId = setTimeout(function () {
        // self.checkViewport()
        self.update();
      }, 100);
    }

    return this.element;
  }

  header(element, config, observers) {
    if (!element || !element.length) {
      return;
    }

    this.element = element;
    this.config = config;

    this.observers = observers && $.isPlainObject(observers) ? observers : {};

    this.viewport = 'xs';

    this.checkViewport();
  }

  _detectObservers() {
    if (!this.element) {
      return;
    }

    let observers = (this.observers = {
      xs: [],
      sm: [],
      md: [],
      lg: [],
      xl: [],
    });

    // Has Hidden Element
    if (this.element.classList.contains('navbar-has-hidden-element')) {
      observers['xs'].push(new HeaderHasHiddenElement(this.element).init());
    }

    // Sticky top
    if (this.element.classList.contains('navbar-sticky-top')) {
      if (this.element.classList.contains('navbar-show-hide')) {
        observers['xs'].push(new HeaderMomentShowHideObserver(this.element).init());
      } else if (this.element.classList.contains('navbar-toggle')) {
        observers['xs'].push(new HeaderHideSectionObserver(this.element).init());
      }

      observers['xs'].push(new HeaderStickyObserver(this.element).init());
    }

    // Floating
    if (this.element.classList.contains('navbar-floating')) {
      observers['xs'].push(new HeaderFloatingObserver(this.element).init());
    }

    if (this.element.classList.contains('navbar-invulnerable')) {
      observers['xs'].push(new HeaderWithoutBehaviorObserver(this.element).init());
    }

    // Abs top & Static
    if (this.element.classList.contains('navbar-absolute-top') || this.element.classList.contains('navbar-static')) {
      if (this.element.classList.contains('navbar-show-hide')) {
        observers['xs'].push(new HeaderShowHideObserver(this.element, this.config).init());
      }
    }

    return observers;
  }

  fixMediaDifference(element) {
    if (!element || !element.length || !element.filter((el) => el.closest('[class*="navbar-side"]')).length) {
      return;
    }

    let toggleable;

    if (element.classList.contains('navbar-side-left-xl') || element.classList.contains('navbar-side-right-xl')) {
      toggleable = element.querySelector('.navbar-expand-xl');

      if (toggleable) {
        toggleable.classList.remove('navbar-expand-xl');
        toggleable.classList.add('navbar-expand-lg');
      }
    } else if (
      element.classList.contains('navbar-side-left-lg') ||
      element.classList.contains('navbar-side-right-lg')
    ) {
      toggleable = element.querySelector('.navbar-expand-lg');

      if (toggleable) {
        toggleable.classList.remove('navbar-expand-lg');
        toggleable.classList.add('navbar-expand-md');
      }
    } else if (
      element.classList.contains('navbar-side-left-md') ||
      element.classList.contains('navbar-side-right-md')
    ) {
      toggleable = element.querySelector('.navbar-expand-md');

      if (toggleable) {
        toggleable.classList.remove('navbar-expand-md');
        toggleable.classList.add('navbar-expand-sm');
      }
    } else if (
      element.classList.contains('navbar-side-left-sm') ||
      element.classList.contains('navbar-side-right-sm')
    ) {
      toggleable = element.querySelector('.navbar-expand-sm');

      if (toggleable) {
        toggleable.classList.remove('navbar-expand-sm');
        toggleable.classList.add('navbar-expand');
      }
    }
  }

  checkViewport() {
    if (window.innerWidth > this.config.breakpointsMap['sm'] && this.observers['sm'].length) {
      this.prevViewport = this.viewport;
      this.viewport = 'sm';

      this.toggleNavbarScrolledClass('sm');

      return this;
    }

    if (window.innerWidth > this.config.breakpointsMap['md'] && this.observers['md'].length) {
      this.prevViewport = this.viewport;
      this.viewport = 'md';

      this.toggleNavbarScrolledClass('md');

      return this;
    }

    if (window.innerWidth > this.config.breakpointsMap['lg'] && this.observers['lg'].length) {
      this.prevViewport = this.viewport;
      this.viewport = 'lg';

      this.toggleNavbarScrolledClass('lg');

      return this;
    }

    if (window.innerWidth > this.config.breakpointsMap['xl'] && this.observers['xl'].length) {
      this.prevViewport = this.viewport;
      this.viewport = 'xl';

      this.toggleNavbarScrolledClass('xl');

      return this;
    }

    if (this.prevViewport) {
      this.prevViewport = this.viewport;
    }

    this.toggleNavbarScrolledClass('xs');

    this.viewport = 'xs';

    return this;
  }

  toggleNavbarScrolledClass(viewport) {
    if (this.config.fixMoment && window.scrollY > this.config.fixMoment) {
      if (typeof this.config.breakpointsMap[viewport] === 'undefined') {
        this.element.classList.remove('navbar-scrolled');
      } else {
        this.element.classList.add('navbar-scrolled');
      }
    }
  }

  notify() {
    if (this.prevViewport) {
      this.observers[this.prevViewport].forEach(function (observer) {
        observer.destroy();
      });

      this.prevViewport = null;
    }

    this.observers[this.viewport].forEach(function (observer) {
      observer.check();
    });

    return this;
  }

  update() {
    for (let viewport in this.observers) {
      this.observers[viewport].forEach(function (observer) {
        observer.destroy();
      });
    }

    this.prevViewport = null;

    this.observers[this.viewport].forEach(function (observer) {
      observer.reinit();
    });

    return this;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const headerElement = document.querySelector('.js-header');
  if (headerElement) {
    new Header(headerElement).init();
  }
});
